<div class="video-preview-container" *ngIf="video">
  <div class="video-wrapper">
    <div class="video-thumbnail">
      <img
        [src]="thumbnailUrl"
        style="
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
        "
      />
    </div>
    <video
      #videoElement
      (loadedmetadata)="onVideoLoaded()"
      (timeupdate)="onTimeUpdate()"
      class="video-element"
    ></video>

    <!-- hidden scrubber video -->
    <video
      #scrubVideo
      muted
      playsinline
      preload="auto"
      style="
        position: absolute;
        left: -99999px;
        width: 1px;
        height: 1px;
        opacity: 0;
        pointer-events: none;
      "
    ></video>
    <div class="video-overlay" (click)="togglePlayPause()">
      <div class="play-button" *ngIf="!isPlaying">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="white"
          stroke="none"
        >
          <polygon points="5 3 19 12 5 21 5 3"></polygon>
        </svg>
      </div>
    </div>
  </div>

  <!-- Video Controls and Timeline -->
  <div class="video-controls">
    <div class="controls-group">
      <button class="control-btn" (click)="rewind()" title="Rewind 5s">
        <nw-icon type="fast_rewind" [size]="20"></nw-icon>
      </button>

      <button class="control-btn play-pause-btn" (click)="togglePlayPause()">
        <nw-icon *ngIf="!isPlaying" type="play_arrow" [size]="20"></nw-icon>
        <nw-icon *ngIf="isPlaying" type="pause" [size]="20"></nw-icon>
      </button>

      <button class="control-btn" (click)="forward()" title="Forward 5s">
        <nw-icon type="fast_forward" [size]="20"></nw-icon>
      </button>
    </div>

    <div
      #timeline
      class="timeline"
      (click)="onTimelineClick($event)"
      (mouseenter)="onTimelineMouseEnter()"
      (mouseleave)="onTimelineMouseLeave()"
      (mousemove)="onTimelineMouseMove($event)"
    >
      <!-- Black background bar with vertical lines -->
      <div class="timeline-track">
        <!-- Plus icon that appears on hover when not over a clip -->
        <div
          *ngIf="showPlusIcon"
          class="timeline-plus-icon"
          [style.left.%]="cursorPercentage"
        >
          <nw-icon type="add" [size]="16" color="black"></nw-icon>
        </div>
        <div
          *ngIf="showRemoveIcon"
          class="timeline-plus-icon"
          [style.left.%]="cursorPercentage"
        >
          <nw-icon type="remove" [size]="16" color="black"></nw-icon>
        </div>

        <div class="timeline-track-line left"></div>
        <div class="timeline-track-line right"></div>
        <ng-container *ngFor="let clip of clips; let i = index">
          <div
            class="timeline-track-line current"
            [style.left.%]="getPlayheadPercentage()"
          >
            <div class="triangle"></div>
          </div>
          <div class="timeline-start" [style.left.%]="getPercentage(clip.from)">
            <app-draggable
              (dx)="dragStart($event, i)"
              (dragEnd)="endDragIntervalStart()"
            >
              <div class="timeline-marker start-marker"></div>
              <div class="timeline-time-label">{{ formatTime(clip.from) }}</div>
            </app-draggable>
          </div>
          <div class="timeline-end" [style.left.%]="getPercentage(clip.to)">
            <app-draggable
              (dx)="dragIntervalEnd($event, i)"
              (dragEnd)="endDragIntervalEnd()"
            >
              <div class="timeline-marker end-marker"></div>
              <div
                class="timeline-time-label"
                [class.close]="getIsStartEndClose(i)"
              >
                {{ formatTime(clip.to) }}
              </div>
            </app-draggable>
          </div>
          <div
            class="timeline-range"
            (click)="onClipClick(i)"
            [style.left.%]="getPercentage(clip.from)"
            [style.width.%]="getPercentage(clip.to) - getPercentage(clip.from)"
          ></div>
        </ng-container>
      </div>
    </div>

    <div class="time-display">
      <span class="current-time">{{ formatTime(currentTime) }}</span>
      <span class="time-separator">/</span>
      <span class="total-time">{{ formatTime(duration) }}</span>
    </div>
  </div>
</div>
